import { useContext } from 'react';
import { type MixpanelContext, MixpanelAppContext } from '@context/mixpanel/mixpanelContext';

export const useMixpanel = (): MixpanelContext => useContext(MixpanelAppContext);
